import { formatHHmmTime, useTimezone } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvTimeCellTransformer = (): {
  getTimeValue: CsvCellTransformerFn;
} => {
  const { timezone } = useTimezone();

  const getTimeValue = ({
    value,
    timeFormat,
  }: ICsvColumnTransformer): string => {
    return formatHHmmTime(value, timeFormat, timezone);
  };

  return { getTimeValue };
};
